<template>
  <div class="layout" ref="Layout" :style="layoutOffsetStyle">
    <a-back-top>
      <div class="antd-back-top"><a-icon type="caret-up" /></div>
    </a-back-top>
    <Header ref="HeaderWrap" :key="`header-top-${$store.state.loginStateKey}`" class="header_visible" />
    <div id="LayoutHeader" ref="BackTopDom" />
    <!-- AntBlockSkeleton 不加入骨架屏,获取权限刷新页面会重复发送请求 -->
    <AntBlockSkeleton height="50rem" :loading="!$store.state.loginStateKey">
      <div class="router_view" :class="{ 'niu-trans-hidden': niuTransMask }">
        <keep-alive :include="include"><router-view :key="$store.state.loginStateKey" /></keep-alive>
      </div>
    </AntBlockSkeleton>
    <Footer
      v-show="($route.path != '/standard') && ($route.path != '/detailsPage/benchmarking') && ($route.path != '/smartQA')"
      :class="{ 'niu-trans-hidden': niuTransMask }"
    />
    <Login v-if="$store.state.visibleLogin" @onOff="onOff" />

    <!-- 英文版翻译遮罩：中文在背后渲染供翻译，用户看不到中文闪现 -->
    <div v-show="niuTransMask" class="niu-trans-mask" data-niu-skip="1" :style="maskOffsetStyle">
      <div class="niu-trans-mask__panel">
        <a-spin size="large" />
        <p class="niu-trans-mask__text">Loading English version…</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './header';
import Footer from './footer';
import Login from '@/views/login';
import {
  bootstrapNiuTrans,
  scheduleTranslate,
  stopAutoTranslateObserver,
  onNiuTransMask,
  cancelPendingTranslate,
} from '@/utils/niuTrans';
import niuConfig from '@/config/niuTrans';

export default {
  components: { Header, Footer, Login },
  data() {
    return {
      visible: true,
      subsidiary: this.$FN.elVisible(this.fn, { visible: true, rootMargin: "0px" }),
      dom: null,
      include: "home", // 需要缓存的组件
      footerShow: false,
      niuTransMask: false,
      _offNiuMask: null,
      headerOffset: 0,
      _headerRo: null,
    }
  },
  computed: {
    layoutOffsetStyle() {
      return this.headerOffset ? { paddingTop: `${this.headerOffset}px` } : null;
    },
    maskOffsetStyle() {
      return this.headerOffset ? { top: `${this.headerOffset}px` } : null;
    },
  },
  watch: {
    '$route': {
      deep: true,
      handler: function (to, from) {
        this.dom && this.scrollTop();
        this.$nextTick(() => this.syncHeaderOffset());
        if (this.$store.state.language !== 'english') return;
        // 无论上一页是否译完：立刻取消，再按新路由静默补翻
        // 不软藏 .router_view，避免影响 iframe/PDF 等页面逻辑与控制台报错
        cancelPendingTranslate();
        scheduleTranslate(niuConfig.routeDelay || 200, { withMask: false });
        scheduleTranslate(900, { withMask: false, debounce: false });
        scheduleTranslate(2200, { withMask: false, debounce: false });
      }
    },
    '$store.state.language'() {
      this.$nextTick(() => this.syncHeaderOffset());
    },
    '$store.state.loginStateKey'() {
      this.$nextTick(() => this.bindHeaderObserver());
    },
  },
  created() {
    this.$FN.occurSimultaneously()
  },
  mounted() {
    this.getRef();
    this.getMainDom();
    this.seFooterShow();
    this._offNiuMask = onNiuTransMask((visible) => {
      this.niuTransMask = visible;
    });
    // 已是英文缓存时：先遮罩再译，避免首屏中文（仅首次进入）
    if (this.$store.state.language === 'english') {
      this.niuTransMask = true;
    }
    bootstrapNiuTrans(this.$store);
    this.bindHeaderObserver();
    window.addEventListener('resize', this.syncHeaderOffset);
    // this.encryptedMediaExtensions();
  },
  beforeDestroy() {
    if (this._offNiuMask) this._offNiuMask();
    stopAutoTranslateObserver();
    window.removeEventListener('resize', this.syncHeaderOffset);
    if (this._headerRo) {
      this._headerRo.disconnect();
      this._headerRo = null;
    }
  },
  methods: {
    // 防止截屏录屏
    // encryptedMediaExtensions() {

    // },
    getHeaderEl() {
      const wrap = this.$refs.HeaderWrap;
      return (wrap && wrap.$el) || this.$el.querySelector('.header_visible');
    },
    syncHeaderOffset() {
      const el = this.getHeaderEl();
      if (!el) return;
      const h = Math.ceil(el.getBoundingClientRect().height);
      if (h > 0 && h !== this.headerOffset) this.headerOffset = h;
    },
    bindHeaderObserver() {
      if (this._headerRo) {
        this._headerRo.disconnect();
        this._headerRo = null;
      }
      this.$nextTick(() => {
        const el = this.getHeaderEl();
        if (!el) return;
        this.syncHeaderOffset();
        if (typeof ResizeObserver !== 'undefined') {
          this._headerRo = new ResizeObserver(() => this.syncHeaderOffset());
          this._headerRo.observe(el);
        }
      });
    },
    onOff(value = false) {
      this.$store.commit('setVisibleLogin', value);
    },
    getRef() {
      let fn = () => {
        let refs = this.$refs.BackTopDom;
        this.subsidiary(refs);
      };
      fn();
    },
    fn(_, flag) { this.visible = flag },
    // 让页脚最后在渲染
    seFooterShow() {
      let time = setTimeout(() => {
        this.footerShow = true;
        clearTimeout(time);
        time = null;
      }, 1000);
    },
    getMainDom() {
      this.dom = this.$refs.BackTopDom
    },
    scrollTop() {
      this.dom && this.dom.scrollIntoView({ behavior: "instant", block: "center" });
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");

.niu-trans-hidden {
  visibility: hidden;
}

.niu-trans-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 6.6rem;
  bottom: 0;
  z-index: 998;
  background: rgb(241, 241, 241);
  display: flex;
  align-items: center;
  justify-content: center;

  &__panel {
    text-align: center;
  }

  &__text {
    margin-top: 16px;
    color: #666;
    font-size: 14px;
  }
}
</style>
